// extracted by mini-css-extract-plugin
export var colorSquare = "_po-0";
export var danger = "_po-5";
export var lightPink = "_po-8";
export var neutralBlue = "_po-7";
export var neutralYellow = "_po-6";
export var normal = "_po-1";
export var primary = "_po-2";
export var primaryLight = "_po-3";
export var solidBlack = "_po-g";
export var solidGreen = "_po-b";
export var solidLightBlue = "_po-d";
export var solidNavy = "_po-c";
export var solidOrange = "_po-f";
export var solidPink = "_po-e";
export var solidRed = "_po-9";
export var solidYellow = "_po-a";
export var success = "_po-4";